import { createSelector } from 'reselect'
import { isPpagGallerySelector } from '~/app/store/config/reducer'
import { getDesignCreationTypes } from '~/app/store/debug/reducer'
import { hasImageSelector } from '~/app/store/designPersonalization/selectors'
import { DESIGN_CREATION_TYPE } from '~/shared/constants'

/**
 * Returns the effective `designCreationTypes` to send to Design Conductor.
 *
 * When photo personalization is applied on PPAG galleries, `Clipart` is excluded.
 * Otherwise the raw value from state is passed through.
 */
export const effectiveDesignCreationTypesSelector = createSelector(
  getDesignCreationTypes,
  isPpagGallerySelector,
  hasImageSelector,
  (rawDesignCreationTypes, isPpagGallery, imagePersonalized) =>
    isPpagGallery && imagePersonalized ? rawDesignCreationTypes?.filter((type) => type !== DESIGN_CREATION_TYPE.CLIPART) : rawDesignCreationTypes,
)
